import './ContactsInfo.scss';

const ContactsInfo = () => {
    return <div className='contacts-info'>
        <div className='contacts-info__item'>
            {process.env.REACT_APP_MAIN_NAME_STUDIO}
        </div>
        <div className='contacts-info__item'>
            Телефон: <a href={`tel:${process.env.REACT_APP_MAIN_TELEFON_URL}`}>{process.env.REACT_APP_MAIN_TELEFON}</a>
        </div>
        <div className='contacts-info__item'>
            Адрес: {process.env.REACT_APP_MAIN_ADDRESSE}
        </div>
        <div className='contacts-info__item'>
            {process.env.REACT_APP_MAIN_INFO}
        </div>
        <div className='contacts-info__item'>
            <a href={`${process.env.REACT_APP_MAIN_VK_LINK}`} target='_blank' rel="noreferrer">{process.env.REACT_APP_MAIN_VK_NAME}</a>
        </div>
        <div className='contacts-info__item'>
            <a href={`${process.env.REACT_APP_MAIN_VK_LINK_2}`} target='_blank' rel="noreferrer">{process.env.REACT_APP_MAIN_VK_NAME_2}</a>
        </div>
    </div>
}

export default ContactsInfo;
